export default __webpack_public_path__ + "static/media/freewill-rob-brezsny.0431c94e.jpg";